module.exports = __webpack_public_path__ + "media/ben_laugh.3041e964.mp3";